import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import './assets/iconfont/iconfont.css'

import api from './api' // 导入api接口
Vue.prototype.$api = api; // 将api挂载到vue的原型上

import ElementUI from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css';
Vue.use(ElementUI);

import Component from '@/components'
Vue.use(Component)

Vue.config.productionTip = false

// 全局修改默认配置，点击空白处不能关闭弹窗
ElementUI.Dialog.props.closeOnClickModal.default = false
// 全局修改默认配置，按下ESC不能关闭弹窗
ElementUI.Dialog.props.closeOnClickModal.default = false


// 图形拖拽
import SlideVerify from 'vue-monoplasty-slide-verify';
Vue.use(SlideVerify)


import AMap from 'vue-amap'
Vue.use(AMap)
AMap.initAMapApiLoader({
  key: '55a6753fa9668f4fe2a84ec5a94c05d3',
  plugin: ['AMap.Autocomplete', 'AMap.PlaceSearch', 'AMap.Scale', 'AMap.OverView','AMap.Geolocation', 'AMap.ToolBar', 'AMap.MapType', 'AMap.PolyEditor', 'AMap.CircleEditor'],
  // 默认高德 sdk 版本为 1.4.4
  v: '1.4.4'
})

    

//增加百度统计
var _hmt = _hmt || [];
(function() {
  var hm = document.createElement("script");
  hm.src = "https://hm.baidu.com/hm.js?909ad948a57f10f3c497e3e173f808cd";
  var s = document.getElementsByTagName("script")[0];
  s.parentNode.insertBefore(hm, s);
})();
router.beforeEach((to, from, next) =>  {
  // console.log(to.path);
   if (to.path) {
     if (window._hmt) {
       window._hmt.push(['_trackPageview', '/#' + to.fullPath]);
     }
   }
   next();
  })
new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')
